export const COLORS = {
  AI_GRADIENT: {
    FROM: '#D93F0C',
    TO: '#C52F86',
  },
};

export const AI_GRADIENT_PROPERTIES = {
  from: COLORS.AI_GRADIENT.FROM,
  to: COLORS.AI_GRADIENT.TO,
};
